import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import SwiperCore, { SwiperOptions, Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare var $: any;


SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

@Component({
  selector: 'app-propertie-view',
  templateUrl: './propertie-view.component.html',
  styleUrls: ['./propertie-view.component.css']
})
export class PropertieViewComponent implements OnInit {
  @Input() propertyData: any;
  inquiryData = {
  name: '',
  email: '',
  phone: ''
};
  propertyList: any[] = [];
  currentPropertId: any = '';
  propertyImages : any = []
  is_fav : any = false
  amenitiesData : any = []
  brochures:any = [];
  subscriptionInfo : any = null
  propertyDataInfo : any = null
  socialForm: FormGroup;
  propertyType = "";
  lat: number; 
  lng: number;
  iframeUrl: SafeResourceUrl;
  adminUserID = environment.ADMIN_USER_ID;
  isPropertyValid = false;
  developerMobile: string = '';
developerEmail: string = '';
developerWhatsappNumber: string = '';

  constructor(public shared: SharedService, public apiService: ApiServiceService, private route: ActivatedRoute,private fb: FormBuilder, private sanitizer: DomSanitizer) {
    this.socialForm = this.fb.group({
      contact: ['', Validators.required],
      email: ['', Validators.required],
      whatsapp_number: ['', Validators.required],
    });
    this.shared.isWhiteMenu = true
  }

  public swiperOp: SwiperOptions = {
    slidesPerView: 3,
    direction: 'horizontal',
    navigation: true,
    hashNavigation: true,
    pagination: false,
    observer: true,
    observeParents: true,
    parallax:true,
    breakpoints: {
      350: {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      500: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      680: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1300: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }
  };


  sliderData : any = [
    {
      "image" : "assets/images/img-1.png",
      "text" : "Slide 1"
    },
    {
      "image" : "assets/images/img-2.png",
      "text" : "Slide 2"
    },
    {
      "image" : "assets/images/img-3.png",
      "text" : "Slide 3"
    },
    {
      "image" : "assets/images/img-4.png",
      "text" : "Slide 4"
    },
    {
      "image" : "assets/images/img-5.png",
      "text" : "Slide 5"
    },
    {
      "image" : "assets/images/img-6.png",
      "text" : "Slide 6"
    },
    {
      "image" : "assets/images/img-7.png",
      "text" : "Slide 7"
    },
    {
      "image" : "assets/images/img-8.png",
      "text" : "Slide 8"
    }
  ]

  onSlideChange() {
    console.log('slide change');
  }
  
  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id'); 
    console.log("id", id);
    this.currentPropertId = id
    this.getData();
    // this.updateId();

  } 
 
  async getData() {
    // const id = this.route.snapshot.paramMap.get('id'); 
    // console.log("id", id);
    console.log("this.currentPropertId",this.currentPropertId)
    let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.PROPERTY_VIEW + "/" +this.currentPropertId);

    if (res && res.data) {
      this.propertyData = res.data;
       this.developerMobile = this.propertyData?.PropertyToDeveloper?.developer_mobile || '';
    this.developerEmail = this.propertyData?.PropertyToDeveloper?.developer_email || '';
    this.developerWhatsappNumber = this.propertyData?.PropertyToDeveloper?.developer_whatsapp_no || '';

      let property_name = this.shared.generateUrlSlug(this.propertyData.property_name);

      const propertyNameInUrl = this.route.snapshot.paramMap.get('property-name'); 
      if(propertyNameInUrl && (propertyNameInUrl != property_name)) {
        if(this.shared.isBrowser()) {
          window.location.href = "/";
        }
        this.isPropertyValid = false;
      } else {
        this.isPropertyValid = true;
      }


      // SEO
      let pageTitle = [];
      if(this.propertyData.property_name) {
        pageTitle.push(this.propertyData.property_name);
      }
      if(this.propertyData.tagline) {
        pageTitle.push(this.propertyData.tagline);
      }
      let image = null;
      if(this.propertyData.PropertyToPropertyMediaData && this.propertyData.PropertyToPropertyMediaData[0] && this.propertyData.PropertyToPropertyMediaData[0].images) {
        let imageArr = this.propertyData.PropertyToPropertyMediaData[0].images.split(",");
        console.log("imageArr", imageArr);
        if(imageArr && imageArr[0]) {
          image = environment.IMAGE_URL + imageArr[0];
        }
      }
      console.log("image", image);

      this.shared.setSEOData(pageTitle.join(" | "), {
        description: this.propertyData.resale_description,
        image: image,
        url: environment.DOMAIN + "view-property/" + this.currentPropertId
      })

      this.propertyData.propertyTypeValue = "";
      this.propertyData.sellRentTagline = "";
      if(this.propertyData.property_type_id && this.propertyData.property_type_id == 5) {
        this.propertyData.propertyTypeValue = this.propertyData.other_property_type;
      } else if (this.propertyData.PropertyToMasterPropertyTypeData ){
        this.propertyData.propertyTypeValue = this.propertyData.PropertyToMasterPropertyTypeData.property_type;
      }

      this.lat = 0;
      this.lng = 0; 

      if(this.propertyData.address_lat) {
        this.lat = this.propertyData.address_lat*1;
      }
      if(this.propertyData.address_log) {
        this.lng = this.propertyData.address_log*1;
      }
      try {
        if(this.propertyData.amenities_json2) {
          this.propertyData.amenities_json2 = JSON.parse(this.propertyData.amenities_json2);
        } else {
          this.propertyData.amenities_json2 = [];
        }
      } catch(e) {
        this.propertyData.amenities_json2 = [];
      }

      try {
        if(this.propertyData.payment_plan) {
          this.propertyData.payment_plan = JSON.parse(this.propertyData.payment_plan);
        } else {
          this.propertyData.payment_plan = [];
        }
      } catch(e) {
        this.propertyData.payment_plan = [];
      }

      this.propertyData.resale_description = this.formatText(this.propertyData.resale_description);
      this.propertyType = "";
      if(this.propertyData && this.propertyData.property_type_id) {
        if(this.propertyData.property_type_id == 5) {
          this.propertyType = this.propertyData.other_property_type;
        } else if (this.propertyData && this.propertyData.PropertyToMasterPropertyTypeData) {
          this.propertyType = this.propertyData.PropertyToMasterPropertyTypeData.property_type;
        }
      }
      if(this.propertyData.brochure) {
        this.brochures = this.propertyData.brochure.split(",")
      }  

      this.isFavP()
      this.getPropertyImages()
      this.getPropertyAmenities()

      if(this.lat != 0 && this.lng != 0) {
        this.iframeUrl = (`https://maps.google.com/maps?q=${this.lat},${this.lng}&hl=es;z=14&output=embed`);
      }

      console.log(this.propertyData);
      // setTimeout(() => {
      //   if(this.propertyData.address_lat && this.propertyData.address_log) {
      //     this.initMap(this.propertyData.address_lat, this.propertyData.address_log);
      //   }
      // })
    } else {
      window.location.href = "/";
    }
  }
  openInquiryModal() {
  const modalEl = document.getElementById('inquiryModal');
  if (modalEl) {
    const modal = new (window as any).bootstrap.Modal(modalEl);
    modal.show();
  }
}
async submitInquiry() {
  // Basic validation
  if (!this.inquiryData.name || !this.inquiryData.email || !this.inquiryData.phone) {
   // this.shared.showError('Please fill all required fields.');
    return;
  }

  // Prepare payload
  const payload = {
    developer_id: this.propertyData?.developer_id || null,
    name: this.inquiryData.name,
    email: this.inquiryData.email,
    mobile: this.inquiryData.phone,
    property_id: this.propertyData?.id || null,
  };

  // Send API request
  const res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.ADD_INQUIRY, payload);

  if (res && !res.error) {
    this.shared.displaySuccessMessage({ msg: res.message });
    const modalEl = document.getElementById('inquiryModal');
    if (modalEl) {
      const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
      if (modal) modal.hide();
    }

    // Reset form
    this.inquiryData = { name: '', email: '', phone: '' };
  } else {
    //this.shared.showError('Failed to submit inquiry. Please try again.');
  }
}


  async updateId() {
    const id = this.route.snapshot.paramMap.get('id'); 
    this.currentPropertId = id;
  }

  paymentType(id: any) {
    let type = ''
    if (id == 1) {
      type = 'Monthly'
    } else if (id == 2) {
      type = 'Quarterly'
    } else if (id == 3) {
      type = 'Yearly'
    }
    return type;
  }

  // onCall(phone: any) {
  //   if (!this.shared.isUserLoggedIn) {
  //     this.fromButtonLogin = true;
  //   }else{
  //   document.location.href = "tel:+" + phone;
  //   }
  // }

  // onMail(mail: any) {
  //   if (!this.shared.isUserLoggedIn) {
  //     this.fromButtonLogin = true;
  //   }else{
  //   document.location.href = "mailto:" + mail;
  //   }
  // }

  // onWp(phone: any) {
  //   if (!this.shared.isUserLoggedIn) {
  //     this.fromButtonLogin = true;
  //   } else {
  //     let phone_no = 971 + phone
  //     let url = "https://api.whatsapp.com/send?phone=" + phone_no;
  //     window.open(url, "_blank");
  //   }
  // }

  getPropertyImages(){
    // if(this.propertyData.selling_type == 1 && this.propertyData.property_construction_type == 2 && this.propertyData.brochure){
    //   //brocher logic
    //   if(this.propertyData.brochure.includes(',')){
    //     this.propertyImages.push(this.propertyData.brochure.split(',')[0])
    //     }else{
    //       this.propertyImages.push(this.propertyData.brochure)
    //     }
    // }else {
    for (let i of this.propertyData.PropertyToPropertyMediaData) {
      if (i.images.includes(',')) {
        for (let _img of i.images.split(',')) {
          this.propertyImages.push({ name: this.getImageCateory(i.category_type), image: _img });
        }
      } else {
        this.propertyImages.push({ name: this.getImageCateory(i.category_type), image: i.images.trim() });
      }
    }
    // }
    // console.log("this.propertyImages",this.propertyImages)
  }

  getImageCateory(id:any){
    let category_name = ''
    for(let i of configuration.propertyImageCategory){
      if(i.id == id){
        category_name = i.name
      }
    }
    return category_name
  }

  async isFavP() {
    if (this.propertyData && this.shared.isUserLoggedIn) {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CHECK_FAVOURITE_PROPERTY, {
        "property_id": this.propertyData.id
      });
      if (res && !res.error) {
        if (res.data && res.data.length > 0) {
          this.is_fav = true
        } else {
          this.is_fav = false
        }
      }
    } else {
      this.is_fav = false
    }
  }

  async favouriteProperty() {
    // console.log("btnn")
    if (!this.shared.isUserLoggedIn) {
      this.shared.fromButtonLogin = true;
    } else {
      // console.log("on btnnnnnnnnnnnn")
      let is_favourite = true;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.FAVOURITE_PROPERTY, {
        "property_id": this.propertyData.id,
        is_favourite
      });
      if (res && !res.error) {
        this.is_fav = true
      }
    }
  }

  async onUnfavouriteProperty() {
    if (!this.shared.isUserLoggedIn) {
      this.shared.fromButtonLogin = true;
    } else {
      let is_favourite = false;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.FAVOURITE_PROPERTY, {
        "property_id": this.propertyData.id,
        is_favourite
      });
      if (res && !res.error) {
        this.is_fav = false
      }
    }
  }
  

  onClose(e: any) {
    console.log("close calling");
    this.shared.fromButtonLogin = false;
  }

  getPropertyAmenities() {
    if (this.propertyData.amenities_json) {
      const amenitiesJson = JSON.parse(this.propertyData.amenities_json);
      console.log("amenitiesJson", amenitiesJson)
      for (let key in amenitiesJson) {
        console.log(amenitiesJson[key]);
        if (amenitiesJson[key] != 'No' && amenitiesJson[key] != 'no' && amenitiesJson[key] != '0' && amenitiesJson[key] != 0) {
          var modifiedKey = key.replace(/_/g, ' ').replace(/\b\w/g, function (char) {
            return char.toUpperCase();
          });
          this.amenitiesData.push({
            "name": modifiedKey,
            "value": amenitiesJson[key]
          });
        }
      }
    }
  }

  downloadBrochure(b:any) {
    window.location.href = environment.IMAGE_URL + b;
  }
  onPopup(type: string) {
  if (!this.shared.isUserLoggedIn) {
    this.shared.fromButtonLogin = true;
    return;
  }

  if (type === 'call') {
    window.location.href = `tel:${this.developerMobile}`;
  }

  if (type === 'email') {
    window.location.href = `mailto:${this.developerEmail}`;
  }

  if (type === 'whatsapp') {
    const phone = this.developerWhatsappNumber.replace(/\D/g, ''); // remove spaces or symbols
    window.open(`https://wa.me/${phone}`, '_blank');
  }
}
  
  async checkAccessToViewProperty() {
    if(this.shared.isUserLoggedIn) {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CAN_VIEW_PROPERTY, {
        property_id: this.propertyData.id
      });
      if (res && !res.error && res.data) {
        if (res.data.subscriptionData) {
          this.subscriptionInfo = res.data.subscriptionData;
        }
        if (res.data.proeprtyData) {
          this.propertyDataInfo = res.data.proeprtyData
        }
        // this.subscriptionMessage = res.message;
        // this.currentInvoiceId = res.data.invoice_id
      }
    } else {
      this.subscriptionInfo = {
        hasSubscription: false
      }
    }
  }

  closeModal(){
    setTimeout(() => {
      $('#socialModal').modal('hide');  
    });
  }

  onURL(data, type: any) {
    if (type == "phone") {
      document.location.href = "tel:+" + data.PropertyToUserData.phone;
    } else if (type == 'email') {
      document.location.href = "mailto:" + data.PropertyToUserData.email;
    } else {
      let phone = data.PropertyToUserData.whatsapp_no ? data.PropertyToUserData.whatsapp_no : data.PropertyToUserData.phone
      let phone_no = 971 + phone
      let url = "https://api.whatsapp.com/send?phone=" + phone_no;
      window.open(url, "_blank");
    }
  }
  
  async onSave() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.ADD_CONTACTED_PROPERTY, {
    })
    if (res && !res.error) {
      // setTimeout(() => {
      //   $('#socialModal').modal('hide');
      // });
      // window.location.reload();
    }
  }


  formatText(text) {
    // Convert text inside || to bold
    text = text.replace(/\|  \|([^|]+)\|  \|/, '<strong>$1</strong><br />');
    text = text.replace(/\|  \|([^|]+)\|  \|/g, '<br /><br /><strong>$1</strong><br />');
    text = text.replace(/\|/g, '<br />');
    // Replace numbers with li tags
    text = text.replace(/1\./g, '<li>').replace(/2\./g, '</li><li>')
              .replace(/3\./g, '</li><li>').replace(/4\./g, '</li><li>') + '</li>';

    return text;
  }


  initMap(lat, lng) {
    // Specify the latitude and longitude
    // var latLng = {lat: lat*1, lng: lng*1}; // Example: New York City
    // console.log("latLng", latLng);
    // // Create a map object and specify the DOM element for display.
    // var map = new google.maps.Map(document.getElementById('map'), {
    //     center: latLng,
    //     zoom: 10
    // });

    // // Create a marker and set its position.
    // var marker = new google.maps.Marker({
    //     map: map,
    //     position: latLng,
    //     title: 'New York City!'
    // });
  }

}
